var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWater50PercentIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 20,
    viewBox: "0 0 14 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.725 10.625C10.81 8.525 8.335 4.565 6.98 2.455C5.625 4.57 3.15 8.525 2.235 10.625C1.85 11.49 1.63 12.42 1.585 13.36C1.585 14.72 2.155 16.02 3.165 16.98C4.175 17.94 5.55 18.48 6.98 18.48C8.41 18.48 9.785 17.94 10.795 16.98C11.805 16.02 12.375 14.715 12.375 13.36C12.335 12.42 12.115 11.495 11.725 10.625ZM6.975 0.507574C6.97831 0.50255 6.98 0.5 6.98 0.5H6.97C6.97 0.5 6.97168 0.50255 6.975 0.507574ZM1.235 10.23C2.53901 7.23959 6.80865 0.759655 6.975 0.507574C7.14135 0.759655 11.411 7.23959 12.715 10.23C13.16 11.225 13.41 12.285 13.45 13.36C13.45 14.985 12.77 16.55 11.555 17.7C10.34 18.855 8.695 19.5 6.975 19.5C5.255 19.5 3.61 18.85 2.395 17.7C1.18 16.55 0.5 14.99 0.5 13.36C0.545 12.28 0.79 11.22 1.235 10.23ZM2.44495 13.3051C2.46495 12.7701 2.54995 12.2401 2.70495 11.7251H11.2549C11.4049 12.2401 11.4949 12.7701 11.5149 13.3051C11.5149 14.4901 11.0349 15.6251 10.1849 16.4651C9.33495 17.3051 8.17995 17.7751 6.97995 17.7751C5.77995 17.7751 4.62495 17.3001 3.77495 16.4651C2.92495 15.6251 2.44495 14.4901 2.44495 13.3051Z",
    fill: "black"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWater50PercentIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Water50_percent_icon.7e45c08ea66475026523eacda30a423c.svg";